<template>
  <section class="bg-white rounded-xl border border-gray-100 shadow-sm p-5 md:p-6">
    <div class="tw-flex items-center justify-between mb-4">
      <h3 class="text-base font-semibold text-gray-900 m-0">Interact (Forum)</h3>
    </div>
    <p class="text-sm text-gray-500 mt-0 mb-3">The graph below shows the evolution of total posts.</p>

    <div v-if="posts" class="chart-container">
      <div class="chart-main">
        <SimpleLineChart :data="postsChartData" :show-final-value="true"/>
      </div>
      <div class="chart-aside">
        <ChartLegend :data="postsChartData" :show-final-value="true"/>
      </div>
    </div>

    <p class="text-sm text-gray-500 mt-6 mb-3">The graph below shows the evolution of total posts interactions.</p>
    <div v-if="postsInteractions" class="chart-container">
      <div class="chart-aside chart-aside-left">
        <ChartLegend :data="postsInteractionsChartData" :show-final-value="true"/>
      </div>
      <div class="chart-main chart-main-right">
        <SimpleLineChart :data="postsInteractionsChartData"/>
      </div>
    </div>

    <div v-if="mostPopularPages" class="mt-6">
      <h4 class="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">Most popular announcements / events</h4>
      <div class="overflow-x-auto">
        <table class="w-full text-sm border-collapse">
          <thead>
          <tr class="border-b border-gray-200 text-left text-xs font-semibold uppercase tracking-wide text-gray-400">
            <th class="py-2 pr-4 font-semibold">Title</th>
            <th class="py-2 pr-4 font-semibold">Type</th>
            <th class="py-2 pr-4 font-semibold">Page views</th>
            <th class="py-2 font-semibold">Unique Visits</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="page in mostPopularPages" class="border-b border-gray-100 hover:bg-gray-50">
            <td class="py-2 pr-4"><a class="text-primary hover:underline" :href="convertUrl(page.url)">{{ page.notification.title ?? convertUrl(page.url) }}</a></td>
            <td class="py-2 pr-4 text-gray-600">{{ page.notification.type ? page.notification.type : 'unknown' }}</td>
            <td class="py-2 pr-4 text-gray-600">{{ page.visits }}</td>
            <td class="py-2 text-gray-600">{{ page.unique_visitors }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </section>
</template>

<script>
  import EcosystemInfoCard from './EcosystemInfoCard.vue'
  import ChartLegend from './ChartLegend.vue'
  import { parseChartData } from '../../Chart/chartsMixin.js'
  import SimpleLineChart from '../../Chart/SimpleLineChart.vue'

  export default {
    props: {
      posts: Object,
      postsInteractions: Object,
      mostPopularPages: Object,
    },
    components: {
      EcosystemInfoCard,
      ChartLegend,
      SimpleLineChart,
    },
    computed: {
      postsInteractionsChartData () {
        const datasets = []
        if (!this.postsInteractions) {
          return
        }
        if (this.postsInteractions.total_likes != null) {
          datasets.push({
            color: '#FBA52C',
            data: this.postsInteractions.total_likes_per_month,
            cumulate: true,
            finalValue: this.postsInteractions.total_likes,
            label: 'Total Likes',
          })
        }
        if (this.postsInteractions.total_comments != null) {
          datasets.push({
            color: '#2E59FA',
            data: this.postsInteractions.total_comments_per_month,
            cumulate: true,
            finalValue: this.postsInteractions.total_comments,
            label: 'Total Comments',
          })
        }
        if (this.postsInteractions.total_unique_posters != null) {
          datasets.push({
            color: '#AF52FF',
            data: this.postsInteractions.total_unique_posters_per_month,
            cumulate: true,
            finalValue: this.postsInteractions.total_unique_posters,
            label: 'Total unique posters',
          })
        }
        return parseChartData(datasets)
      },
      postsChartData () {
        const datasets = []

        if (!this.posts) {
          return
        }

        if (this.posts.total_announcements_per_month) {
          datasets.push({
            color: '#FBA52C',
            data: this.posts.total_announcements_per_month,
            finalValue: this.posts.total_announcements,
            cumulate: true,
            label: 'Total Announcements',
          })
        }
        if (this.posts.total_events_per_month) {
          datasets.push({
            color: '#2E59FA',
            data: this.posts.total_events_per_month,
            finalValue: this.posts.total_events,
            cumulate: true,
            label: 'Total Events',
          })
        }
        if (this.posts.total_posts) {
          datasets.push({
            color: '#AF52FF',
            data: this.posts.total_posts,
            cumulate: true,
            finalValue: Number(this.posts.total_events) + Number(this.posts.total_announcements),
            label: 'Total Posts',
          })
        }

        return parseChartData(datasets)
      },
    },
    methods: {
      convertUrl (pageUrl) {
        return `${window.location.protocol}//${window.location.hostname}${pageUrl}`
      },
    },
  }
</script>
